import { render } from "./VendorModel.vue?vue&type=template&id=c01ce04a&scoped=true"
import script from "./VendorModel.vue?vue&type=script&lang=js"
export * from "./VendorModel.vue?vue&type=script&lang=js"

import "./VendorModel.vue?vue&type=style&index=0&id=c01ce04a&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c01ce04a"]])

export default __exports__